export default __webpack_public_path__ + "static/media/panDashboardIcon.76cc795d.svg";